/*
 * 인증 토큰 저장소 (자동로그인 지원)
 *
 *  - 자동로그인 ON  → localStorage  (브라우저 재시작해도 유지, 백엔드 30일 토큰)
 *  - 자동로그인 OFF → sessionStorage (브라우저/탭 닫으면 사라짐, 백엔드 8시간 토큰)
 *
 * 두 저장소 중 어디에 있든 읽을 수 있도록 getter가 양쪽을 모두 조회한다.
 * 모든 토큰/사용자명 접근은 이 헬퍼를 경유한다.
 */

const TOKEN_KEY = 'token';
const USER_KEY = 'username';

export const getToken = (): string | null =>
  localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);

export const getUsername = (): string | null =>
  localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);

/** 로그인 성공 시 토큰/사용자명을 remember 여부에 맞는 저장소에 기록 (반대편은 정리) */
export const setAuth = (token: string, username: string, remember: boolean): void => {
  const primary = remember ? localStorage : sessionStorage;
  const secondary = remember ? sessionStorage : localStorage;
  primary.setItem(TOKEN_KEY, token);
  primary.setItem(USER_KEY, username);
  secondary.removeItem(TOKEN_KEY);
  secondary.removeItem(USER_KEY);
};

/** 로그아웃 / 401 시 양쪽 저장소에서 모두 제거 */
export const clearAuth = (): void => {
  [localStorage, sessionStorage].forEach((s) => {
    s.removeItem(TOKEN_KEY);
    s.removeItem(USER_KEY);
  });
};
